<ng-container>
  @if (defaultChartOptions$ | async; as chartOptions) {
    <div class="w-full">
      @if (chartOptions) {
        <div
          class="w-full"
          [ngClass]="{
            'flex items-center': chartOptions.legend?.right || chartOptions.legend?.left,
          }"
        >
          @if (!chartOptions.legend?.top) {
            <div></div>
          } @else {
            <div class="mt-4 flex flex-wrap items-center justify-center gap-y-[10px] space-x-8">
              @for (color of colors; track color) {
                <div class="flex items-center text-sm" (click)="legendAction(color)">
                  @if (color.type === 'bar') {
                    <div
                      class="mr-4 h-4 w-14 border-2"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  @if (color.type === 'line') {
                    <div
                      class="mr-4 h-1 w-14 rounded-full"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  <div
                    class="text-xs"
                    [ngClass]="{ 'text-aux-gray-dark line-through': color.hide }"
                  >
                    {{ color.label }}
                  </div>
                </div>
              }
            </div>
          }
          @if (!chartOptions.legend?.left) {
            <div></div>
          } @else {
            <div class="ml-1 mt-4 grid justify-start font-bold">
              @for (color of colors; track color) {
                <div class="mb-1 flex items-center text-sm" (click)="legendAction(color)">
                  @if (color.type === 'bar') {
                    <div
                      class="mr-4 h-4 w-14 border-2"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  @if (color.type === 'line') {
                    <div
                      class="mr-4 h-1 w-14 rounded-full"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  <div class="text-xs" [ngClass]="{ 'text-aux-gray line-through': color.hide }">
                    {{ color.label }}
                  </div>
                </div>
              }
            </div>
          }
          <div style="height: 250px" class="w-full">
            <canvas
              baseChart
              class="chart"
              [data]="chartOptions.data"
              [options]="chartOptions.options"
              [legend]="false"
              [type]="chartOptions.type"
            ></canvas>
          </div>
          @if (!chartOptions.legend?.bottom) {
            <div class="w-full"></div>
          } @else {
            <div class="mt-4 flex flex-wrap items-center justify-center gap-y-[10px] space-x-8">
              @for (color of colors; track color) {
                <div class="flex items-center text-sm" (click)="legendAction(color)">
                  @if (color.type === 'bar') {
                    <div
                      class="mr-4 h-4 w-14 border-2"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  @if (color.type === 'line') {
                    <div
                      class="mr-4 h-1 w-14 rounded-full"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  <div
                    class="text-xs"
                    [ngClass]="{ 'text-aux-gray-dark line-through': color.hide }"
                  >
                    {{ color.label }}
                  </div>
                </div>
              }
            </div>
          }
          @if (!chartOptions.legend?.right) {
            <div></div>
          } @else {
            <div class="ml-1 mt-4 grid justify-start font-bold">
              @for (color of colors; track color) {
                <div class="mb-1 flex items-center text-sm" (click)="legendAction(color)">
                  @if (color.type === 'bar') {
                    <div
                      class="mr-4 h-4 w-14 border-2"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  @if (color.type === 'line') {
                    <div
                      class="mr-4 h-1 w-14 rounded-full"
                      [ngStyle]="{
                        'background-color': color.color,
                        'border-color': color.color,
                      }"
                    ></div>
                  }
                  <div class="text-xs" [ngClass]="{ 'text-aux-gray line-through': color.hide }">
                    {{ color.label }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</ng-container>
